import React from "react";
import "./Footer.css";
import Logo from "../../assets/dhanushdhari_final_log.jpeg";

import { FaInstagram, FaFacebookF, FaTwitter } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="dd-footer">

      <div className="dd-footer-container">

        {/* LEFT SECTION */}
        <div className="dd-footer-brand">

          <div className="dd-footer-logo">
            <img src={Logo} alt="logo" />
            <h3>Dhanushdhari Burnout Gym</h3>
          </div>

          <p>
            Building modern residential and commercial spaces with
            quality construction and trusted service.
          </p>

        </div>

        {/* SITEMAP */}
        <div className="dd-footer-links">

          <h4>Sitemap</h4>

          <ul>
            <li>About Us</li>
            <li>Projects</li>
            <li>News & Blog</li>
            <li>Help Center</li>
          </ul>

        </div>

        {/* SUPPORT */}
        <div className="dd-footer-links">

          <h4>Support</h4>

          <ul>
            <li>FAQ</li>
            <li>Support Center</li>
          </ul>

        </div>

        {/* SOCIAL */}
        <div className="dd-footer-social">

          <h4>Social Media</h4>

          <div className="dd-social-icons">
            <FaInstagram />
            <FaTwitter />
            <FaFacebookF />
          </div>

        </div>

      </div>

      {/* BOTTOM BAR */}

      <div className="dd-footer-bottom">
        <p>Term of Use</p>
        <p>Privacy Policy</p>
      </div>

    </footer> 
  );
};

export default Footer;